var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/ui/progress-bar/progress-bar.tsx";
import React from 'react';
/** A horizontal meter filled to the given percentage. */
const ProgressBar = ({
  progress
}) => /*#__PURE__*/React.createElement("div", {
  className: "h-2.5 w-full rounded-full bg-gray-100 dark:bg-slate-900/50 overflow-hidden",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 9,
    columnNumber: 3
  }
}, /*#__PURE__*/React.createElement("div", {
  className: "h-full bg-accent-500",
  style: {
    width: `${Math.floor(progress * 100)}%`
  },
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 10,
    columnNumber: 5
  }
}));
export default ProgressBar;